import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-group col-12 px-3 mt-2" }
const _hoisted_2 = { for: "patient-tags" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Tags ")
const _hoisted_4 = {
  tabindex: "0",
  href: "javascript:void(0);",
  role: "button"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary font-size-xs" }, null, -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "d-flex justify-content-end mb-4" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" New Tag ")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-right font-size-xs" }, null, -1 /* HOISTED */)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TagsInput = _resolveComponent("TagsInput")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_custom_popover = _resolveDirective("custom-popover")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Tags",
    type: "his-section",
    "full-height": false,
    "application-id": Number(_ctx.application)
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, [
          _hoisted_3,
          _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_4, _hoisted_6)), [
            [_directive_custom_popover, { content: _ctx.sanitizeMarkup(_ctx.tagsTooltip) }]
          ])
        ]),
        _createVNode(_component_TagsInput, {
          data: _ctx.patientTags,
          tags: _ctx.selectedTags,
          onUpdateTags: _ctx.updateTags,
          placeholder: "Start Typing......",
          "open-on-focus": true
        }, null, 8 /* PROPS */, ["data", "tags", "onUpdateTags"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          class: "btn btn-primary me-3",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.newTagDialog && _ctx.newTagDialog(...args)))
        }, _hoisted_10)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}